export const FETCH_KIOSKS = 'KIOSKS/FETCH_REQUEST';
export const FETCH_KIOSKS_SUCCESS = 'KIOSKS/FETCH_SUCCESS';
export const FETCH_KIOSKS_FAILURE = 'KIOSKS/FETCH_FAILURE';

export const FETCH_KIOSK = 'KIOSK/FETCH_REQUEST';
export const FETCH_KIOSK_SUCCESS = 'KIOSK/FETCH_SUCCESS';
export const FETCH_KIOSK_FAILURE = 'KIOSK/FETCH_FAILURE';

export const PUT_KIOSK = 'KIOSK/PUT_REQUEST';
export const PUT_KIOSK_SUCCESS = 'KIOSK/PUT_SUCCESS';
export const PUT_KIOSK_FAILURE = 'KIOSK/PUT_FAILURE';

export const POST_KIOSK = 'KIOSK/POST_REQUEST';
export const POST_KIOSK_SUCCESS = 'KIOSK/POST_SUCCESS';
export const POST_KIOSK_FAILURE = 'KIOSK/POST_FAILURE';

export const SET_KIOSKS_DASHBOARD_FILTER = 'KIOSKS/DASHBOARD/FILTER/SET';
export const CLEAR_KIOSKS_DASHBOARD_FILTER = 'KIOSKS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_KIOSKS_DASHBOARD_FILTER = 'KIOSKS/DASHBOARD/FILTERS/REMOVE';

export const PERSISTED_ACTION_TYPES = [
  SET_KIOSKS_DASHBOARD_FILTER,
  CLEAR_KIOSKS_DASHBOARD_FILTER,
  REMOVE_KIOSKS_DASHBOARD_FILTER,
];

export const PATCH_STATUS_REQUEST = 'KIOSK/PATCH_STATUS_REQUEST';
export const PATCH_STATUS_SUCCESS = 'KIOSK/PATCH_STATUS_SUCCESS';
export const PATCH_STATUS_FAILURE = 'KIOSK/PATCH_STATUS_FAILURE';

export const DELETE_REQUEST = 'KIOSK/DELETE_REQUEST';
export const DELETE_SUCCESS = 'KIOSK/DELETE_SUCCESS';
export const DELETE_FAILURE = 'KIOSK/DELETE_FAILURE';

export const CONFIGURE_REQUEST = 'KIOSK/CONFIGURE_REQUEST';

export const FETCH_KIOSKS_BY_PAYMENT_TYPES = 'KIOSKS/PAYMENT_TYPES/FETCH_REQUEST';
export const FETCH_KIOSKS_BY_PAYMENT_TYPES_SUCCESS = 'KIOSKS/PAYMENT_TYPES/FETCH_SUCCESS';
export const FETCH_KIOSKS_BY_PAYMENT_TYPES_FAILURE = 'KIOSKS/PAYMENT_TYPES/FETCH_FAILURE';

export const FETCH_KIOSK_URL = 'KIOSK/URL/FETCH_REQUEST';
export const FETCH_KIOSK_MASTER_PIN = 'KIOSK/MASTER_PIN/FETCH_REQUEST';
export const FETCH_KIOSK_SUPPORT_CODE = 'KIOSK/SUPPORT_CODE/FETCH_REQUEST';

export const SET_IS_READY = 'KIOSKS/DETAILS/SET_IS_READY';

export const REQUEST_KIOSK_STATUS = 'KIOSK/REQUEST_STATUS_REQUEST';
export const REQUEST_KIOSK_STATUS_SUCCESS = 'KIOSK/REQUEST_STATUS_SUCCESS';
export const REQUEST_KIOSK_STATUS_FAILURE = 'KIOSK/REQUEST_STATUS_FAILURE';

export const RESET_KIOSK_STATUS = 'KIOSK/RESET_STATUS_REQUEST';

export const FETCH_AVAILABLE_RELAYS_REQUEST = 'KIOSKS/AVAILABLE_RELAYS/FETCH_REQUEST';
export const FETCH_AVAILABLE_RELAYS_SUCCESS = 'KIOSKS/AVAILABLE_RELAYS/FETCH_SUCCESS';
export const FETCH_AVAILABLE_RELAYS_FAILURE = 'KIOSKS/AVAILABLE_RELAYS/FETCH_FAILURE';

export const CHECK_KIOSK_LOCATION_ID_REQUEST = 'KIOSK/LOCATION_ID/CHECK_REQUEST';
